/**
 * Valid field names for LTD (Long-Term Disability) benefits API
 *
 * This set is used to filter out any invalid fields before sending data to the API.
 * Only fields listed here will be included in the API payload.
 */

export const LTD_VALID_FIELDS = new Set<string>([
  "objectType",
  "currentCarrierName",
  "benefitClassAvailability",
  "benefitAmount",
  "maximumAmount",
  "guaranteedIssue",
  "ownOccupationPeriod",
  "definitionOfDisability",
  "gainfulEarningsTestOwnOccupation",
  "gainfulEarningsTestAnyOccupation",
  "eliminationPeriod",
  "benefitDuration",
  "definitionOfEarnings",
  "mentalIllness",
  "substanceAbuse",
  "preExistingCondition",
  "rehab",
  "cola",
  "conversion",
  "waiverOfPremium",
  "employerContribution",
  "otherLimitations",
  "extended",
]);
